<template>
  <div class="master-detail">
    <div class="master">
      <p>Our Values</p>
      <div
        class="master-item"
        v-for="item in items"
        :key="item.id"
        @mouseover="debounceHandleMasterItemHover($event, item)"
        :class="activeItemId === item.id ? 'active' : ''"
      >
        <span v-text="item.title"/>
      </div>
    </div>
    <div class="detail">
      <div
        :ref="`detail-item-${item.id}`"
        class="detail-item"
        v-for="item in items"
        :key="item.id"
      >
        <div class="detail-item__content">
          <img
            :src="getImageUrl(item.imageFilename)"
            :alt="item.title"
          />
          <p v-text="item.imageSubtext"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'MasterDetail',
  props: {
    items: Array
  },
  data () {
    return {
      activeItemId: ''
    };
  },
  created () {
    this.activeItemId = this.items[0].id;
  },
  mounted () {
    this.$activeDetailItem().addClass('active');
    this.debounceHandleMasterItemHover = debounce(
      this.handleMasterItemHover,
      300
    );
  },
  methods: {
    getImageUrl (filename) {
      return require(`../../assets/${filename}`);
    },
    handleMasterItemHover (event, item) {
      if (this.activeItemId === item.id) return;
      const $lastActiveDetailItem = this.$activeDetailItem();
      this.activeItemId = item.id;
      const $activeDetailItem = this.$activeDetailItem();
      $activeDetailItem.addClass('active');
      $lastActiveDetailItem.removeClass('active');
    },
    $activeDetailItem () {
      return $(this.$refs[`detail-item-${this.activeItemId}`]);
    }
  }
};
</script>
